require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./gruppo-di-ricerca-nicola-navone.json") })
        }
      }, "path---gruppo-di-ricerca-nicola-navone");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---gruppo-di-ricerca-nicola-navone!./.cache/json/gruppo-di-ricerca-nicola-navone.json
// module id = 663
// module chunks = 231608221292675